/**
 * YEDEK KOD HARCANDI BANDI — G-AUT-02a
 *
 * ================================================================
 * ŞARTNAME BUNU PANELDE İSTİYOR, ÖĞRENCİDE HİÇ YOKTU
 * ================================================================
 * G-AUT-02a: *"Girişte yedek kod kullanıldığında kullanıcıya kaç kod
 * kaldığı giriş sonrası panelde bir bantla bildirilir; üç ve altına
 * inince bant uyarı tonuna geçer."*
 *
 * Gerekçesi maddenin kendisinde yazılı: on kodun tamamı bitince
 * hesabı **yalnızca yönetici** açabiliyor (G-AUT-03) ve kullanıcı
 * bunu bugüne kadar ancak **kilitlendikten sonra** öğreniyordu.
 * *"Sayı, kodun harcandığı anda söylenmezse söylenecek başka bir an
 * yok."*
 *
 * Ölçüldü (05.09.2026): `ikinciAsama` yanıtı `kalanYedekKod`
 * taşıyor, panel bunu bir bantla gösteriyor
 * (`apps/panel/src/Uygulama.tsx`), **öğrenci uygulaması yanıtı
 * tamamen atıyordu** (`onGirdi: () => void`). Yani telefonunu
 * kaybedip yedek koduyla giren öğrenci, kaç kodu kaldığını ancak
 * Hesabım → Güvenlik ekranına giderse öğrenebiliyordu — ve oraya
 * gitmesi için önce bir sebebi olması gerekiyordu.
 *
 * ================================================================
 * "PANELDE" SÖZCÜĞÜ — DÜRÜST OLMAK GEREKİRSE BELİRSİZ
 * ================================================================
 * Şartname bir yerde iki uygulamayı ayırıyor (*"personel paneli
 * (`apps/panel`) ve öğrenci/veli PWA (`apps/ogrenci`)"*), başka
 * yerlerde "panel"i öğrencinin ekranı için de kullanıyor
 * (*"öğrenci panelden kodlama"*, *"öğrenci kitapçığı panelden
 * indirir"*, *"kendi panelinden önizleyebilir"*).
 *
 * Yani madde harfiyen okunursa öğrenciyi dışarıda bırakıyor olabilir.
 * Buraya yazılmasının sebebi maddenin **gerekçesi**: kilitlenme
 * riski öğrenci için aynı, hatta daha ağır. Emre ya da ana oturum
 * dar okumayı tercih ederse bu dosya tek başına geri alınabilir —
 * `Giris` geri `() => void` olur.
 */

export type BantTonu = "uyari" | "bilgi";

export interface YedekKodBandi {
  metin: string;
  ton: BantTonu;
}

/** Şartnamenin eşiği: "üç ve altına inince bant uyarı tonuna geçer". */
export const UYARI_ESIGI = 3;

/**
 * Girişten sonra gösterilecek bant; yedek kod kullanılmadıysa `null`.
 *
 * `null` = bu girişte yedek kod HARCANMADI (normal 2FA kodu ya da
 * güvenilir cihaz). Sunucu alanı yalnızca yedek kodla girildiğinde
 * dolduruyor — ekran bunu kendisi çıkaramaz, o yüzden `null` sessizce
 * "gösterme" demek.
 */
export function yedekKodBandi(kalan: number | null): YedekKodBandi | null {
  if (kalan === null) return null;

  /*
    SIFIR AYRI CÜMLE. "0 kod kaldı" dilbilgisi olarak doğru ama
    yanlış şeyi söylüyor: kalan bir şey yok. Öğrencinin bir sonraki
    girişte ne olacağını bilmesi gerekiyor, "kaldı" kelimesi orada
    hâlâ bir ihtimal varmış gibi okunuyor.
  */
  const kalanMetni = kalan === 0 ? "Hiç yedek kodunuz kalmadı" : `${kalan} kodunuz kaldı`;

  return {
    metin: `Bir yedek kod harcandı. ${kalanMetni}. Kodlarınız bitince hesabınızı yalnızca yönetici açabilir.`,
    ton: kalan <= UYARI_ESIGI ? "uyari" : "bilgi",
  };
}
